import React from "react";
import { getActivityFromSpecificTrainingAction } from "@icarius-pages/myTraining/actions";
import { useDispatch } from "react-redux";
import ModuleItem from "./moduleItem";

const ActivitySelection = (props) => {

    const {
        trainingData,
        selectedActivityId,
    } = props;

    const dispatch = useDispatch();

    const handleOpenActivity = (activityId) => {
        dispatch(getActivityFromSpecificTrainingAction(trainingData.id, activityId));
    }

    return (
        <>
            {
                trainingData.modules.map((module, indexModule) => {
                    return (
                        <div key={indexModule}>
                            <ModuleItem
                                isInstructor={trainingData.isInstructor}
                                isPreselected={trainingData.currentModuleId === module.id}
                                selectedActivityId={selectedActivityId}
                                data={module}
                                handleOpenActivity={handleOpenActivity}
                            />
                        </div>
                    )
                })
            }
        </>
    );
}

export default ActivitySelection;